import * as React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';

import InspirationItem from '../../components/inspiration/InspirationItem';
import Layout from '../../components/layouts/core';
import SeriesPage from '../../components/series/SeriesPage';

import sunflowers from '../../data/CollectionItems/sunflowers';

import sunflowersCarouselPiece from '../../data/CarouselPieces/sunflowersCarouselPiece';

import getImagesFromNodes from '../../utils/getImagesFromNodes';

export const pageQuery = graphql`
  query {
    allFile(filter: { relativePath: { regex: "/sunflowers-van-gogh-print/" } }) {
      nodes {
        name
        relativePath
        childImageSharp {
          gatsbyImageData(width: 600, height: 600, placeholder: DOMINANT_COLOR, formats: [AUTO, WEBP, AVIF])
        }
      }
    }
  }
`;

const ogDescription = `Boogie-Woogie is an NFT collection from Dandy Lines.
In our Run 1 Van Gogh Series, we look to capture one of Van Gogh's well-known pieces: Sunflowers. We
target this piece, specifically, as we are still iterating our process and this painting offers a 
unique challenge as it maintains a deceptively broad range of similar, yet unique colors.`;

const RunOneMondrianPage = ({ data }) => {
  const images = getImagesFromNodes(data.allFile.nodes);

  return (
    <>
      <Helmet>
        <title>Boogie-Woogie | Run 1 Van Gogh Series</title>
        <meta name='twitter:card' content='summary' />
        <meta name='twitter:site' content='@BoogieWoogieNFT' />
        <meta name='twitter:creator' content='@ics_jim' />
        <meta property='og:url' content='https://boogie-woogie.io/series/run-1-van-gogh' />
        <meta property='og:title' content='Boogie-Woogie | Run 1 Van Gogh Series' />
        <meta property='og:type' content='website' />
        <meta property='og:description' content={ogDescription} />
        <meta property='og:image' content='https://sale.boogie-woogie.io/boogie-woogie-auction-site-run-one.png' />
        <meta property='og:image:width' content='1200' />
        <meta property='og:image:height' content='630' />
      </Helmet>
      <Layout>
        <SeriesPage details={sunflowers.details} seriesName='Run 1 Van Gogh Series' images={images}>
          <InspirationItem
            ReferenceImage={sunflowers.ReferenceImage}
            details={sunflowers.details}
            seriesPage={sunflowers.seriesPage}
            invert
            piece={sunflowersCarouselPiece}
          />
        </SeriesPage>
      </Layout>
    </>
  );
};

export default RunOneMondrianPage;
